import React from 'react';
import { useSelector } from 'react-redux';
import KlarnaPromo from 'src/components/atoms/KlarnaPromo';
import KlarnaSteps from 'src/components/atoms/KlarnaSteps';
import { IReduxState } from 'src/store/reducers';

const PayInFour: React.FC = () => {
  const appointment = useSelector(
    (state: IReduxState) => state.quote.appointment
  );

  // Only promote installments once the job has an estimate.
  if (!appointment?.attributes.estimate) {
    return null;
  }

  let amount = 0;

  if (appointment?.attributes.estimate) {
    amount += appointment.attributes.member_job
      ? appointment.attributes.estimate.total_member_price || 0
      : appointment.attributes.estimate.total_price || 0;
  }

  if (appointment?.attributes.appointment_type === 'diagnosis') {
    amount += appointment.attributes.member_free_diag
      ? 0
      : appointment.attributes.member_job
      ? appointment.attributes.diagnosis_price_member || 0
      : appointment.attributes.diagnosis_price || 0;
  }

  if (!amount || amount <= 0) {
    return null;
  }

  return (
    <>
      <KlarnaSteps />
      <KlarnaPromo amount={amount} />
    </>
  );
};

export default PayInFour;
